import { maskEmail } from "./maskEmail";

// mask emails in text
// add other masking rules here in the future if needed
export const maskText = (text?: string) => {
  if (!text) {
    return undefined;
  }

  const emailRegex = /\b[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+\b/g;
  const matches = text.match(emailRegex);

  if (!matches) {
    return text;
  }

  let result = text;
  for (const email of matches) {
    const masked = maskEmail(email);
    result = result.split(email).join(masked);
  }

  return result;
};
